/** 
 * @Author: v_jppjpeng
 * @Date: 2024-06-22 17:17:39
 * @Explain: 活动 - A/B 测试
 */
export interface ActivityAbTestState {
  /** 是否显示创建AB测试 - 弹窗 */
  createAbTestOptions: {
    isShow: boolean;
  };
  /** 是否内部跳转 */
  isInternalJump: boolean;
  /** 是否开启跳出拦截 */
  isLeaveFlag: boolean;
  /** 选择内容 - 语言tab选中项 */
  languageActive: string;
  /** 草稿缓存 */
  draftCache: {
    id: number;
    tag: string;
    time: 0;
    saveList: any[];
    expandedList: any[];
  };
}

export interface ActivityAbTestReducers {
  setCreateAbTestOptions: (
    state: ActivityAbTestState,
    action: { payload: any },
  ) => any;
  setInterceptRouteStatus: (
    state: ActivityAbTestState,
    action: { payload: any },
  ) => any;
  setTabsActive: (state: ActivityAbTestState, action: { payload: any }) => any;
  setDraftCache: (state: ActivityAbTestState, action: { payload: any }) => any;
  resetDraftCache: (state: ActivityAbTestState, action: { payload: any }) => any;
}


export type ModelType = {
  namespace: string;
  state: ActivityAbTestState;
  reducers: ActivityAbTestReducers
};

const ActivityAbTestModel: ModelType = {
  namespace: 'ActivityAbTestModel',
  state: {
    // 是否显示创建AB测试 - 弹窗
    createAbTestOptions: {
      isShow: false,
    },
    // 是否内部跳转
    isInternalJump: false,
    // 是否开启跳出拦截
    isLeaveFlag: false,
    // 选择内容 - 语言tab选中项
    languageActive: '',
    // 草稿缓存
    draftCache: {
      id: 0,
      tag: '',
      time: 0,
      saveList: [],
      expandedList: [],
    },
  },
  reducers: {
    // 设置AB测试 - 弹窗配置
    setCreateAbTestOptions(state, action) {
      return {
        ...state,
        createAbTestOptions: action.payload,
      };
    },
    // 设置拦截路由状态
    setInterceptRouteStatus(state, action) {
      const { isInternalJump, isLeaveFlag } = action.payload;
      return {
        ...state,
        isInternalJump,
        isLeaveFlag,
      };
    },
    // 设置选择内容 - 语言tab选中项
    setTabsActive(state, action) {
      return {
        ...state,
        languageActive: action.payload,
      };
    },
    // 设置草稿缓存
    setDraftCache(state, action) {
      return {
        ...state,
        draftCache: action.payload,
      };
    },
    // 重置草稿缓存
    resetDraftCache(state, action) {
      return {
        ...state,
        draftCache: {
          id: 0,
          time: 0,
          saveList: [],
          expandedList: [],
        },
        languageActive: '',
      };
    },
  },
};

export default ActivityAbTestModel;
